import { cn } from '@/utils/cn';

interface OverlayProps {
  className?: string;
}

const Overlay: React.FC<OverlayProps> = ({ className = '' }: OverlayProps) => {
  return <div className={cn('absolute inset-0 bg-black opacity-50 pointer-events-auto', className)} />;
};

export default Overlay;
